import { useGetCTAs } from "./queries";

export const useHasPaymentCTAs = (fundID, showing) => {
  const { data: { callToActions = [] } = {}, ...rest } = useGetCTAs({
    fundID,
    enabled: !!fundID && showing,
  });

  const hasPaymentCTAs = callToActions.length > 0;
  return { hasPaymentCTAs, ...rest };
};
